import S from 's-js';

import { EnhancedEstimate } from 'data/models/EnhancedEstimate';
import { EnhancedEstimateQuery } from 'data/models/EnhancedEstimateQuery';
import { WartsilaEnrichmentsResponse } from 'data/models/WartsilaEnrichmentsResponse';

export interface WartsilaEnrichmentsMapParams {
    model : WartsilaEnrichmentsResponse;
}

export type WartsilaEnrichmentsMap = ReturnType<typeof WartsilaEnrichmentsMap>;
export function WartsilaEnrichmentsMap(
    { model } : WartsilaEnrichmentsMapParams
) {
    return {
        RelevantQuery: S(() => model.RelevantQuery() === null ? null : EnhancedEstimateQueryViewModel(model.RelevantQuery()!))
    };
}

export type EnhancedEstimateQueryViewModel = ReturnType<typeof EnhancedEstimateQueryViewModel>;
function EnhancedEstimateQueryViewModel(model : EnhancedEstimateQuery) {
    return {
        Model: model,
        Result: S(() => model.Result() === null ? null : EnhancedEstimateViewModel(model.Result()!))
    };
}

export type EnhancedEstimateViewModel = ReturnType<typeof EnhancedEstimateViewModel>;
function EnhancedEstimateViewModel(model : EnhancedEstimate) {
    return {
        Model: model,
    };
}



// WEBPACK FOOTER //
// ./apps/wartsila/wartsilaenrichments/map.ts